/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import { TextField } from '@material-ui/core';
import React, { useCallback } from 'react';
import { useSelector } from 'react-redux';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';

const ContactTypeCustomTextField = React.memo((props) => {
  const compareContactTypeResult = useSelector(
    (state) => state?.sharedState?.ContactTypeReducer?.compareContactTypeResult
  );

  const checkedHandler = (e) => {
    const { colId } = props.column;

    if (props.type === 'number') {
      const inputValue = e.target.value;
      if (inputValue.match(/^[0-9]+$/)) {
        props.node.setDataValue(colId, parseInt(inputValue));
      } else if (inputValue === '') {
        props.node.setDataValue(colId, null);
      }
      optimiseValidationCall(props, compareContactTypeResult);
    } else {
      const inputValue = e.target.value;
      props.node.setDataValue(colId, inputValue === '' ? '' : inputValue);
      optimiseValidationCall(props, compareContactTypeResult);
    }
  };

  const debounce = (func) => {
    let timer;
    return function (...args) {
      const context = this;
      if (timer) clearTimeout(timer);
      timer = setTimeout(() => {
        timer = null;
        func.apply(context, args);
      }, 300);
    };
  };

  const optimiseValidationCall = useCallback(
    debounce(props.validateBtnDisable),
    []
  );

  return props.column.colId === 'contactTypeCd' && !props.data.isNewRecord ? (
    <span>{props.value}</span>
  ) : (
    <div
      className={`fullWidth w-100 text-${
        props.textAlign || 'left'
      } td-active-cell ${
        props.required && (!props.value || !props.value.trim())
          ? 'tBill-validate'
          : ''
      }`}
      id='ContactType'
    >
      {props && props.value && props.value.length > 25 ? (
        <OverlayTrigger
          placement='bottom'
          overlay={<Tooltip id='filter-tooltip'>{props.value || ''}</Tooltip>}
        >
          <TextField
            fullWidth
            placeholder=''
            InputLabelProps={{
              shrink: true,
            }}
            inputProps={{
              maxlength: props.maxLength || 255,
              'aria-labelledby': 'ContactType',
            }}
            InputProps={{ disableUnderline: true }}
            disabled={props?.isReadOnly || props.disabled || false}
            value={props.value || ''}
            onChange={checkedHandler}
            error={props.required && (!props.value || !props.value.trim())}
            helperText=''
          />
        </OverlayTrigger>
      ) : (
        <TextField
          fullWidth
          placeholder=''
          InputLabelProps={{
            shrink: true,
          }}
          inputProps={{
            maxlength: props.maxLength || 255,
            'aria-labelledby': 'ContactType',
          }}
          InputProps={{ disableUnderline: true }}
          disabled={props?.isReadOnly || props.disabled || false}
          value={props.value || ''}
          onChange={checkedHandler}
          error={props.required && (!props.value || !props.value.trim())}
          helperText=''
        />
      )}
    </div>
  );
});

export default ContactTypeCustomTextField;
